export default function PostSection() {
  return null;
}